<div class="overtime-management flex-column d-flex gap-4">
  <div class="row overtime-management__header align-items-center">
    <div class="col-lg-7 col-md-12 align-self-center">
      <h2 class="h3 m-0">{{ 'executiveStats.title' | transloco }}</h2>
    </div>
    <div class="col-lg-5">
      <app-executive-stats-filter (dateFilterChange)="onDateFilterChange($event)"></app-executive-stats-filter>
    </div>
  </div>
  <div class="row gx-3">
    <div class="col-lg-3 col-md-6">
      <app-cost-per-kilometer-widget [selectedFilter]="getSelectedFilterLabel(dateFilter)"></app-cost-per-kilometer-widget>
    </div>
    <div class="col-lg-3 col-md-6">
      <app-fuel-consumption-widget [selectedFilter]="getSelectedFilterLabel(dateFilter)"></app-fuel-consumption-widget>
    </div>
    <div class="col-lg-3 col-md-6">
      <app-fuel-variance-widget [selectedFilter]="getSelectedFilterLabel(dateFilter)"></app-fuel-variance-widget>
    </div>
    <div class="col-lg-3 col-md-6">
      <app-overtime-hours-widget [selectedFilter]="getSelectedFilterLabel(dateFilter)"></app-overtime-hours-widget>
    </div>
  </div>
  <div class="row row-gap-3 gx-3">
    <div class="col-lg-4">
      <app-violations-widget></app-violations-widget>
    </div>
    <div class="col-lg-4">
      <app-distance-driven-widget></app-distance-driven-widget>
    </div>
    <div class="col-lg-4">
      <app-idle-time-widget></app-idle-time-widget>
    </div>
    <div class="col-lg-4">
      <app-driver-utilisation-widget></app-driver-utilisation-widget>
    </div>
    <div class="col-lg-4">
      <app-trips-widget></app-trips-widget>
    </div>
    <div class="col-lg-4">
      <app-driver-score-widget></app-driver-score-widget>
    </div>
  </div>
</div>